export default {
	setUnreadCount (state, value) {
		state.unreadCount = value;
	}
};
